// extracted by mini-css-extract-plugin
module.exports = {"title":"service-item-module--title--2z-Zc"};